import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteProgramLevel, ProgramActionKeys, programsActionCreators } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* deleteProgramLevelSaga(action: DeleteProgramLevel) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<number>> = yield call(
    api.deleteProgramLevel,
    action.payload.programLevelId
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(programsActionCreators.removeProgramLevel(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteProgramLevel() {
  yield takeEvery(ProgramActionKeys.DELETE_PROGRAM_LEVEL, deleteProgramLevelSaga);
}
